import secondaryButtonLightGrayHover from '../../../../../common/algorithms/secondary-button-light-gray-hover';

const light = (params) => secondaryButtonLightGrayHover(params);

export default light;
